/** News categories — keep in sync with backend News model enum and AdminNews form. */
export const NEWS_CATEGORIES = [
  { value: 'activity', label: 'Activities' },
  { value: 'conference', label: 'Conferences' },
  { value: 'graduation', label: 'Graduation' },
] as const;

export type NewsCategory = (typeof NEWS_CATEGORIES)[number]['value'];

export const newsCategoryLabelMap: Record<NewsCategory, string> = {
  activity: 'Activities',
  conference: 'Conferences',
  graduation: 'Graduation',
};

/** Map stored / legacy category values to the three public tabs. */
export const normalizeNewsCategory = (category?: string): NewsCategory => {
  if (category === 'conference' || category === 'graduation') return category;
  if (category === 'publication' || category === 'award') return 'conference';
  if (
    category === 'activity' ||
    category === 'event' ||
    category === 'notice' ||
    category === 'other'
  ) {
    return 'activity';
  }
  return 'activity';
};

export const isNewsCategory = (value: string): value is NewsCategory =>
  NEWS_CATEGORIES.some((c) => c.value === value);
